module.exports = __webpack_public_path__ + "static/weather-report-home-bac0ae7bfd98270f8cda6b8cfb9373bd.png";